<template>
    <div v-if="visible">
        <!-- Backdrop -->
        <div class="modal-backdrop fade show"></div>
        <!-- Modal Container -->
        <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h5 class="modal-title">Logistica de venta No. {{ despacho.venta.numcontrol }}</h5>
                        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Modal Body -->
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="camionSelect">Seleccione el Camión</label>
                            <select id="camionSelect" class="form-control" v-model="camionSeleccionado"
                                :disabled="selectDisabled" required>
                                <option value="">Seleccione un camión</option>
                                <option v-for="camion in camiones.filter(c => c.estatus)" :key="camion.id" :value="camion.id">
                                    {{ camion.codigo }} - {{ camion.descripcion }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- Modal Footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModal">Cerrar</button>
                        <template v-if="selectDisabled">
                            <button type="button" class="btn btn-warning"
                                @click="habilitarReasignacion">Reasignar</button>
                        </template>
                        <template v-else>
                            <button type="button" class="btn btn-primary" @click="guardarAsignacion">Guardar
                                asignación</button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
export default {
    name: "AsignarDespachoModal",
    props: {
        despacho: {
        },
        // Si se envía un ID de camión, el modal se abre en modo asignado (select deshabilitado).
        inicialCamion: {
            type: [Number, String],
            default: ''
        }
    },
    data() {
        return {
            visible: false,
            camiones: [],
            camionSeleccionado: '',
            observacion: '',
            // Si ya hay una asignación, el select estará inicialmente deshabilitado.
            selectDisabled: false,
        };
    },
    methods: {
        abrirModal() {
            this.visible = true;
            // Encadenamos la llamada a cargarCamiones para asegurarnos de que se complete antes de asignar.
            this.cargarCamiones().then(() => {
                if (this.inicialCamion) {
                    this.camionSeleccionado = this.inicialCamion;
                    this.selectDisabled = true;
                } else {
                    this.selectDisabled = false;
                }
            });
        },
        cerrarModal() {
            this.visible = false;
            // Reiniciamos campos
            this.camionSeleccionado = '';
            this.observacion = '';
            this.selectDisabled = false;
        },
        cargarCamiones() {
            return api
                .get("/almacen")
                .then(response => {
                    // Suponiendo que la API devuelve un array de camiones:
                    this.camiones = response.data;
                })
                .catch(error => {
                    console.error("Error al cargar camiones:", error);
                });
        },
        habilitarReasignacion() {
            // Habilitamos el select para poder escoger otro camión
            this.selectDisabled = false;
        },
        guardarAsignacion() {
            // Payload para actualizar el despacho de la venta, modificando almacen_id
            const payload = {
                almacen_id: this.camionSeleccionado,
                status: 'asignado' // Se envía el id del camión como almacen_id
            };
            console.log('camion seleccionado', payload)
            // Se asume que this.despachoId contiene el id del registro de despachoventas a actualizar
            api.put(`/despachoventas/${this.despacho.id}`, payload)
                .then(response => {
                    // Emitir un evento para que el componente padre actualice la información
                    this.$emit("despachoAsignado", response.data);
                    alert("Despacho asignado/reasignado correctamente");
                    // Se vuelve a deshabilitar el select o se cierra el modal, según se requiera
                    this.selectDisabled = true;
                    this.cerrarModal();
                })
                .catch(error => {
                    console.error("Error al guardar asignación:", error);
                    alert("Hubo un error al asignar el despacho");
                });
        }
    }
};
</script>
<style scoped>
.modal-body { max-height: 60vh; overflow-y: auto; }
</style>